import { SvgIcon, SvgIconProps } from '@mui/material';
import { useEffect, useState } from 'react';

/* eslint-disable-next-line */
export interface CcfDancingDotsIconProps extends SvgIconProps {}

/**
 * Component used to display dancing dots icon
 * @param props - CcfDancingDotsIconProps
 * @returns
 * @example
 */
export function CcfDancingDotsIcon(props: CcfDancingDotsIconProps) {
  const [selectedCircle, setSelectedCircle] = useState(1);

  useEffect(() => {
    const timer = setTimeout(() => {
      setSelectedCircle((prevCircle) => (prevCircle > 3 ? 1 : prevCircle + 1));
    }, 500);

    return () => clearTimeout(timer);
  }, [selectedCircle]);

  return (
    <SvgIcon width="66" height="36" viewBox="0 0 66 36" fill="none" {...props}>
      <rect width="66" height="36" rx="4" fill="#ECF3F8" />
      <circle
        cx="21"
        cy="18"
        r={selectedCircle === 1 ? '7' : '4'}
        fill="#79797A"
      />
      <circle
        cx="36"
        cy="18"
        r={selectedCircle === 2 ? '7' : '4'}
        fill="#79797A"
      />
      <circle
        cx="51"
        cy="18"
        r={selectedCircle === 3 ? '7' : '4'}
        fill="#79797A"
      />
    </SvgIcon>
  );
}

export default CcfDancingDotsIcon;
